module.exports = __webpack_public_path__ + "static/CM-popup-nis-check-5b472a92bb59f68040728130475b9a31.jpg";